<script setup lang="ts">
const props = defineProps<{
  image: string | null;
}>();

const emit = defineEmits(["close"]);
</script>

<template>
  <template v-if="props.image">
    <section class="view-image">
      <div class="view-box">
        <div class="close">
          <button class="btn btn-sm btn-default" @click="emit('close')">x</button>
        </div>
        <div class="content">
          <img :src="props.image" alt="View Image" />
        </div>
      </div>
    </section>
  </template>
</template>

<style lang="scss" scoped>
.view-image {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100dvh;
  background: var(--black-transparent);

  .view-box {
    display: flex;
    flex-direction: column;
    width: 60%;
    height: 90%;
    margin-block: auto;
    margin-inline: auto;
    background: var(--white);
    overflow: hidden;
    border-radius: 0.5rem;
    padding: 0.5rem;
    gap: 0.75rem;

    .close {
      display: flex;
      justify-content: flex-end;
    }

    .content {
      flex: 1;
      overflow: auto;
      padding: 0.5rem;

      img {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .view-image {
    .view-box {
      width: 90%;
      height: 90%;
    }
  }
}
</style>
